module.exports = __webpack_public_path__ + "images/perspective.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/perspective.png
// module id = 624
// module chunks = 0